// extracted by mini-css-extract-plugin
export default {"container":"BooleanValue_container__-sCiE","check":"BooleanValue_check__WG0aH","remove":"BooleanValue_remove__2gLSO","uncheckedLabel":"BooleanValue_uncheckedLabel__nWgms"};